const DataMain = () => import('../../components/Tenant/DataMain/DataMain')

export default {
    path: 'tenant-data-main',
    redirect: 'tenant-data-main',
    component: {
        template: '<router-view></router-view>',
    },
    name: 'tenant-data-main',
    meta: {'permissions': 'view-tenant-data-main'},
    children: [
        {
            path: '/',
            component: DataMain,
        },
    ],
};
